import { INexusProviderServices } from './interfaces/INexusProviderServices';
import { NexusAgentsService } from './services/NexusAgentsService';
import { NexusConversationMessagesService } from './services/NexusConversationMessagesService';
import { NexusConversationWriteService } from './services/NexusConversationWriteService';
import { NexusConversationsService } from './services/NexusConversationsService';
import { NexusPromptEnhancerService } from './services/NexusPromptEnhancerService';
import { ChatProviderType } from '../../../domain/chat/models/ChatProviderType';
import { NexusChatTitleGenerationService } from './services/NexusChatTitleGenerationService';
import { NexusMcpServersService } from './services/NexusMcpServersService';


export class NexusProviderServices implements INexusProviderServices {
    public readonly providerType = ChatProviderType.Nexus;
    public readonly sessions;
    public readonly messages;
    public readonly sessionWrite;
    public readonly agents;
    public readonly mcpServers;
    public readonly promptEnhancer;
    public readonly titleGenerator;

    constructor(baseUrl: string) {
        this.sessions = new NexusConversationsService(baseUrl);
        this.messages = new NexusConversationMessagesService(baseUrl);
        this.sessionWrite = new NexusConversationWriteService(baseUrl);
        this.agents = new NexusAgentsService(baseUrl);
        this.mcpServers = new NexusMcpServersService(baseUrl);
        this.promptEnhancer = new NexusPromptEnhancerService(baseUrl);
        this.titleGenerator = new NexusChatTitleGenerationService(baseUrl);
    }
}

